import React, { useState, useEffect } from "react";
import styles from "./notifications.module.css"; // Custom styles
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faTimes, faFileAlt, faSpinner } from "@fortawesome/free-solid-svg-icons";
import axios from 'axios';
import { Link } from 'react-router-dom';
import Modal from 'react-modal';

const baseURL = `${process.env.REACT_APP_API_URL}`

const ContractNotification = ({ contract }) => {
    const [notifications, setNotifications] = useState([])
    const [loading, setLoading] = useState(true)
    const [modalIsOpen, setmodalIsOpen] = useState(false);
    const [selectedContract, setSelectedContract] = useState(null)
    const [modalLoading, setModalLoading] = useState(false)


    useEffect(() => {
        fetchNotifications()
    }, [])

    const fetchNotifications = async () => {
        try {
            const response = await axios.get(`${baseURL}/profiles/notification_list/`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
                },
            });
            setNotifications(response.data)
            setLoading(false)

        } catch (error) {
            console.error('Error fetching notifications:', error);
            setLoading(false)
        }
    }

    const handleMarkAsRead = async (notificationId) => {
        try {
            const confirmed = window.confirm("You are about to mark this contract as Read")
            if (confirmed) {
                const response = await axios.put(
                    `${baseURL}/profiles/notification_mark_as_read/${notificationId}/`,
                    {is_read: true},
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
                        },
                    }
                );
                setNotifications(prev=>
                    prev.map(notification=>
                        notification.id === notificationId
                        ? {...notification, is_read: response.data.is_read}
                        : notification
                    )
                );
                closeModal()
                await fetchNotifications()
                alert('Notification marked as read')
            }
            
        } catch (error) {
            console.error('Error marking notification as read:', error);   
            alert('Error marking notification as read, Please try again');
            closeModal(); 
        }
    };

    const handleAccept = async (contractId) => {
        try {
            const confirmed = window.confirm("Are you sure you want to accept this contract?")
            if (confirmed) {
                await axios.put(
                    `${baseURL}/profiles/contract_accept/${contractId}/`,
                    {status: 'Accepted'},
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
                        },
                    }
                );
                setNotifications(prev => 
                    prev.map(notification =>
                        notification.contract_id === contractId
                        ? {...notification, status: 'Accepted'}
                        : notification
                    )
                )
                fetchNotifications()
                alert('Contract accepted')
                closeModal();
            }
            
        } catch (error) {
            console.error('Error accepting contract:', error);
            alert('Error accepting contract, Please try again');
        }
        
    };

    const handleDecline = async (contractId) => {
        try {
            const confirmed = window.confirm("You are about to decline this contract!")
            if (confirmed) {
                await axios.put(
                    `${baseURL}/profiles/contract_decline/${contractId}/`,
                    {status: 'Declined'},
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
                        },
                    }
                );
                setNotifications(prev =>
                    prev.map(notification =>
                        notification.contract_id === contractId
                        ? {...notification, status: 'Declined'}
                        : notification
                    )
                )
                fetchNotifications()
                alert('Contract declined')
                closeModal();
            }
            
        } catch(error) {
            console.error('Error declining contract:', error);
            alert('Error declining contract, Please try again');
        }

    };

    const openModal = async (notificationId) => {
        setModalLoading(true)
        try {
            console.log('Fetching contract details for ID:', notificationId)
            const response = await axios.get(`${baseURL}/profiles/contract_notification/${notificationId}/`, {
                headers : {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
                },
            })
            setmodalIsOpen(true);
            setSelectedContract(response.data);
        } catch (error) {
            console.error('Error fetching contract details:', error);
        } finally {
            setModalLoading(false)
        }
        
    };

    const closeModal = () => {
        setmodalIsOpen(false)
        setSelectedContract(null)
    }

    if (loading) return (
        <div className={styles.loadingContent}>
          <FontAwesomeIcon icon={faSpinner} spin size="3x" className={styles.spinner} />
          <span className={styles.loadingText}>Loading...</span>
        </div>
      );

    return (
        <div className={styles.contractNotification}>
            <div className={styles.header}>
                <FontAwesomeIcon icon={faFileAlt} className={styles.icon} />
                <h3>Notifications</h3>
                <p>
                </p>
            </div>

            <div className={styles.body}>
                {notifications.map((notification) => (
                    <div key={notification.id}>
                        <p><strong>Type:</strong> {notification.type}</p>
                        <p><strong>Message:</strong> {notification.message_template}</p>
                        <p>
                            <strong>Sender: </strong> 
                            
                            <Link
                                to={`/profile/${notification.sender_role}/${notification.sender_id}`}
                                key={notification.id}
                                className={styles.resultCard}
                            >
                                 {notification.sender_name}
                            </Link>
                        </p>
                        
                        
                        <p>
                            <strong>Status:</strong> {" "}
                            {notification.is_read ? "Read" : "Unread"}
                        </p>
                        <p><strong>Received Date: </strong>{new Date(notification.created_at).toLocaleDateString()}</p>
                        <div style={{display: 'flex', flexDirection: 'column'}}>
                            <button onClick={() => openModal(notification.id)} className={styles.viewDetails} aria-label="View notification details">
                                View Details
                            </button>
                            <span key={notification.id}>
                                {!notification.is_read &&(
                                    <button onClick={() => handleMarkAsRead(notification.id)} style={{background: '#ffc107', color: 'white', border: 'none', padding: '8px', cursor: 'pointer'}}>
                                        <FontAwesomeIcon icon={faCheck} /> Read
                                    </button>
                                )}
                            </span>
                        </div>
                        
                    </div>
                ))}

                {modalIsOpen && (
                    <Modal
                        isOpen={modalIsOpen}
                        onRequestClose={closeModal}
                        contentLabel="Contract Details"
                        className={styles.modal}
                        overlayClassName={styles.overlay}
                    >
                        <h2>Contract Details</h2>
                        {modalLoading ? (
                            <p>Loading...</p>
                        ) : selectedContract ? (
                            <div>
                                <p><strong>Terms:</strong> {selectedContract.terms}</p>
                                <p><strong>Start Date:</strong> {selectedContract.start_date}</p>
                                <p><strong>End Date:</strong> {selectedContract.end_date}</p>
                                <p><strong>Status:</strong> {selectedContract.status}</p>
                                <p><strong>Payment Amount:</strong> ${selectedContract.payment_amount}</p>
                                <p><strong>Days Per Month:</strong> {selectedContract.days_per_month}</p>
                                <p><strong>Payment Status:</strong> {selectedContract.payment_status}</p>
                                <p><strong>Payment Method:</strong> {selectedContract.payment_method}</p>
                                <p><strong>Renewable:</strong> {selectedContract.is_renewable}</p>
                                <p><strong>Payment Day:</strong> {selectedContract.payment_day}</p>
                                <p><strong>Contract Document:</strong> <img src={`${baseURL}${selectedContract.contract_document}`} alt={selectedContract.terms}/></p>
                                <p><strong>Termination Date:</strong> {selectedContract.termination_date}</p>
                                <p><strong>Termination Reason:</strong> {selectedContract.termination_reason || 'N/A'}</p>
                                <div className={styles.actions}>
                                    {selectedContract.status ==='Pending' && (
                                        <>
                                            <button onClick={()=> handleAccept(selectedContract.id)} className={styles.acceptButton}>
                                                <FontAwesomeIcon icon={faCheck} /> Accept
                                            </button>
                                            <button onClick={()=> handleDecline(selectedContract.id)} className={styles.declineButton}>
                                                <FontAwesomeIcon icon={faTimes} /> Decline
                                            </button>
                                        </>
                                    )}
                                </div>
                            </div>
                            
                        ) : (
                            <p>No contract details found.</p>
                        )}
                        <div className={styles.divButtons}>
                            <button onClick={closeModal} className={styles.closeButton}>
                                <FontAwesomeIcon icon={faTimes} /> Close
                            </button>
                            {notifications.map((notification) => (
                                <span key={notification.id}>
                                    {!notification.is_read &&(
                                        <button onClick={() => handleMarkAsRead(notification.id)} className={styles.markAsReadButton}>
                                            <FontAwesomeIcon icon={faCheck} /> Read
                                        </button>
                                    )}
                                </span>
                            ))}
                        </div>
                    </Modal>
                )}

                
            </div>
        </div>
    );
};

export default ContractNotification;